import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  Col,
  Input,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Offcanvas,
  OffcanvasBody,
  OffcanvasHeader,
  Row,
} from "reactstrap";

import Select from "react-select";
import "../css/TableSelect.css";
import PropTypes from "prop-types";

const FoodCourt = ({
  isOpen,
  toggle = () => {},

  setSelectedCourt = () => {},
  data, // ← array of tables from API (your "sectionData")
  loading,
  handleRefresh,
  isRefreshing,
}) => {
  const [searchQuery, setSearchQuery] = useState("");
  const [tempSelectedTable, setTempSelectedTable] = useState(null);
  const [showAddModal, setShowAddModal] = useState(false);
  const [newTableName, setNewTableName] = useState("");

  // Determine status from IsOccupied & Ispending
  const getTableStatus = (table) => {
    switch (table?.QuickOrderStatus) {
      case 2:
        return "billPrinted";
      case 0:
        return "occupied";
      default:
        return "unknown";
    }
  };
  const getStatusIcon = (table) => {
    switch (table?.QuickOrderStatus) {
      case 2:
        return (
          <span className="text-dark">
            <i class="ri-printer-line"></i>
          </span>
        );
      case 0:
        return null;
      default:
        return null;
    }
  };
  const filteredTables =
    data?.filter((table) => {
      if (!table.TableKey) return false;
      const tableKeyString = String(table.TableKey).toLowerCase();
      const query = searchQuery.toLowerCase().trim();
      return tableKeyString.includes(query);
    }) || [];

  const handleConfirm = () => {
    if (tempSelectedTable) {
      setSelectedCourt(tempSelectedTable);

      localStorage.setItem("selectedCourt", JSON.stringify(tempSelectedTable));
      toggle();
    }
  };

  const handleTap = (table) => {
    setTempSelectedTable(
      tempSelectedTable?.TableKey === table.TableKey ? null : table
    );
  };

  const handleAddTempTable = () => {
    if (!newTableName.trim()) return;
    const currentTime = new Date().toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
    });

    const tempTable = {
      TableKey: newTableName,
      OrderTime: currentTime,
      isTemp: true,
    };
    setSelectedCourt(tempTable);
    localStorage.setItem("selectedCourt", JSON.stringify(tempTable));
    setShowAddModal(false);
    toggle();
  };

  return (
    <>
      <Offcanvas
        isOpen={isOpen}
        toggle={toggle}
        direction="end"
        backdropClassName="bg-dark bg-opacity-50"
        className="shadow-lg animate__animated animate__slideInRight bg-white rounded-start"
        id="offcanvasRight"
      >
        {/* Header & Search omitted for brevity */}
        {/* Mobile Header */}
        <OffcanvasHeader className="d-block d-sm-none">
          <div className="d-flex justify-content-between align-items-center w-100 rounded-top">
            <button className="btn btn-sm btn-light back-btn" onClick={toggle}>
              <i className="bx bx-chevron-left"></i>
            </button>
            <div className="d-flex align-items-center text-center justify-content-center w-100 gap-2">
              <i className="ri-stack-line"></i>
              <h5 className="mb-0">Table Selection</h5>
            </div>
          </div>
        </OffcanvasHeader>

        {/* Desktop Close Button */}
        <div
          className="position-absolute d-none d-sm-block"
          style={{ left: "-40px", top: "10px" }}
        >
          <button className="btn btn-sm btn-light" onClick={toggle}>
            <i className="ri-close-line"></i>
          </button>
        </div>

        {/* Desktop Header */}
        <div className="d-none d-sm-flex justify-content-start align-items-center p-3 shadow-sm rounded-top custom-modal-header">
          <i className="ri-stack-line"></i>
          <h5 className="mb-0 ms-2 modal-title">Table Selection</h5>
        </div>
        <OffcanvasBody className=" bg-body-tertiary custom-modal-body">
          <Row className=" h-25">
            <Col md={6} xs={7} lg={3} className="mb-2 ">
              <div className="position-relative">
                <i className="ri-search-line position-absolute top-50 start-0 translate-middle-y ms-3 text-muted" />
                <Input
                  type="text"
                  placeholder="Search for table..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  className="ps-5 py-2 rounded-pill border shadow-sm w-100"
                  style={{ fontSize: "14px" }}
                />
                {searchQuery && (
                  <i
                    className="ri-close-line position-absolute top-50 end-0 translate-middle-y me-3 text-danger cursor-pointer"
                    onClick={() => setSearchQuery("")}
                  />
                )}
              </div>
            </Col>
            <Col xs={3} lg={4} className="">
              <button
                className="btn btn-success"
                onClick={() => setShowAddModal(true)}
              >
                + Add
              </button>
            </Col>
            <Col xs={2} className="d-block d-lg-none d-md-none ">
              <div
                className="d-flex align-items-center gap-2 cursor-pointer"
                onClick={!isRefreshing ? handleRefresh : null}
              >
                <i
                  className={`ri-refresh-line fs-5 ${
                    isRefreshing ? "refresh-rotate" : ""
                  }`}
                  title="Refresh"
                  style={{ opacity: isRefreshing ? 0.5 : 1 }}
                ></i>
              </div>
            </Col>

            {/* Add Table Button */}
          </Row>

          {/* Table Grid */}
          <div className="table-grid-wrapper">
            <div className="table-grid">
              {loading ? (
                <div className="d-flex justify-content-center align-items-center w-100 my-5">
                  <Spinner color="primary" />
                </div>
              ) : filteredTables?.length > 0 ? (
                filteredTables?.map((table) => {
                  const status = getTableStatus(table);
                  return (
                    <div
                      key={table?.TableKey}
                      onClick={() => handleTap(table)}
                      className={`table-card table-${status} table-capacity-12 ${
                        tempSelectedTable?.TableKey === table.TableKey
                          ? "table-selected"
                          : ""
                      }`}
                    >
                      <div className="table-content">
                        <div className="status-icon-wrapper">
                          {getStatusIcon(table)}
                        </div>

                        <div className="table-name">{table?.TableKey}</div>
                        <div className="table-name">{table?.OrderTime}</div>
                      </div>
                    </div>
                  );
                })
              ) : (
                <div className="text-center my-5">
                  <i className="ri-emotion-unhappy-line display-4 text-secondary" />
                  <h5 className="fw-semibold text-secondary">
                    No Tables Available
                  </h5>
                  <p className="text-muted mb-0">
                    Please check back later or refresh.
                  </p>
                </div>
              )}
            </div>
          </div>
        </OffcanvasBody>

        {/* Footer */}
        <ModalFooter
          className="p-2 custom-modal-footer"
          style={{ backgroundColor: "#f9fafb" }}
        >
          <div className="footer-content">
            {tempSelectedTable && (
              <span className="selected-info d-lg-flex d-none">
                Selected Table: <strong>{tempSelectedTable.TableKey}</strong>
              </span>
            )}
            <div className="text-end">
              <button
                onClick={handleConfirm}
                disabled={!tempSelectedTable}
                className="btn btn-success btn-continue"
              >
                Continue
              </button>
            </div>
          </div>
        </ModalFooter>
      </Offcanvas>

      {/* Add Temporary Table Modal */}
      <Modal
        isOpen={showAddModal}
        toggle={() => setShowAddModal(false)}
        centered
      >
        <ModalHeader toggle={() => setShowAddModal(false)}>
          Add Temporary Table
        </ModalHeader>
        <ModalBody>
          <Input
            placeholder="Enter table name"
            value={newTableName}
            onChange={(e) => setNewTableName(e.target.value)}
          />
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => setShowAddModal(false)}>
            Cancel
          </Button>
          <Button color="primary" onClick={handleAddTempTable}>
            Add
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

FoodCourt.propTypes = {
  isOpen: PropTypes.bool,
  toggle: PropTypes.func,
  selectedTable: PropTypes.object,
  setSelectedCourt: PropTypes.func,
  data: PropTypes.shape({
    id: PropTypes.number,
    tables: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        tableName: PropTypes.string,
        capacity: PropTypes.number,
        tableStatus: PropTypes.string,
        section: PropTypes.object,
      })
    ),
  }),
  sectionData: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
    })
  ),
  setSelectedSection: PropTypes.func,
  selectedSection: PropTypes.object,
  loading: PropTypes.bool,
};

export default FoodCourt;
